import moment from "moment";
import React from "react";
import formatDateDDMMYYYY from "../../../../Main/formatDate";

const InvoiceA5 = React.forwardRef((props, ref) => {
  const { values } = props;

  console.log(values, "values?.values");

  return (
    <div className="a5-landscape" ref={ref} style={styles.container}>
      <style>
        {`
         @page a5-landscape {
            size: A5 landscape;
            margin-top: 4.2cm;
            margin-bottom: 2cm;
            margin-left: 0.5cm;
            margin-right: 0.5cm;
          }
          
          @media print {
            .a5-landscape {
              width: 100%;
              height: 100%;
              page-break-inside: avoid;
              page-break-after: always;
            }

            
            .a5-landscape + * {
              display: none !important;
            }
          }
          
          .a5-landscape {
            page: a5-landscape;
          }
          
          @media print {
            .print-header {
              position: fixed;
              top: 0cm;  
              left: 0.5cm;
              right: 0.5cm;
              height: auto;
              z-index: 10;
            }

            thead {
              display: table-header-group;
            }

            thead tr.spacer td {
              height: 40px; 
              border: none;
            }

            tfoot {
              display: table-footer-group;
            }
          }
        `}
      </style>

      {/* Billing values */}
      {/* <div style={styles.billingvalues}>
        <div className="text-xs text-regular">
          <span>Customer :</span> {props?.customerName}
        </div>
        <p>
          <strong>Address:</strong> {props?.customerAddress}
        </p>
        <p>
          <strong>Date:</strong> {props?.date}
        </p>
      </div> */}
      <div className="print-header">
        <div className="text-regular text-xs pb-6">
          <div className="flex justify-between">
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>Customer</td>
                    <td className="px-2">:</td>
                    <td className="text-right">
                      {values?.customer?.name
                        ? values?.customer?.name
                        : "Walk-in-customer"}
                    </td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td className="px-2">:</td>
                    <td className="text-right">
                      {values?.customer?.phone ? values?.customer?.phone : ""}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>Invoice No</td>
                    <td className="px-2">:</td>
                    <td className="text-right">#INV-{values?.number}</td>
                  </tr>
                  <tr>
                    <td>Date</td>
                    <td className="px-2">:</td>
                    <td className="text-right">
                      {formatDateDDMMYYYY(values?.date)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="print-content">
        <table style={styles.table}>
          <thead>
            <tr class="spacer">
              <td colspan="100%"></td>
            </tr>
            <tr style={styles.tableHeader}>
              <th
                className="text-left pl-2 text-xs text-regular"
                style={styles.tableCell}
              >
                S.No
              </th>
              <th
                className="text-left text-xs text-regular"
                style={styles.tableCell}
              >
                Description
              </th>
              <th
                className="text-center text-xs text-regular"
                style={styles.tableCell}
              >
                Batch
              </th>
              <th
                className="text-center text-xs text-regular"
                style={styles.tableCell}
              >
                Expiry
              </th>
              <th
                className="text-center text-xs text-regular"
                style={styles.tableCell}
              >
                Unit
              </th>
              <th
                className="text-center text-xs text-regular"
                style={styles.tableCell}
              >
                Quantity
              </th>
              <th
                className="text-center text-xs text-regular"
                style={styles.tableCell}
              >
                Price
              </th>
              <th
                className="text-center text-xs text-regular"
                style={styles.tableCell}
              >
                Tax
              </th>
              <th
                className="text-center text-right pr-2 text-xs text-regular"
                style={styles.tableCell}
              >
                Total
              </th>
            </tr>
          </thead>
          <tbody className="text-regular">
            {values?.details?.map((item, index) => (
              <tr key={index}>
                <td className="text-center text-xs" style={styles.tableCell}>
                  {index + 1}
                </td>
                <td className="text-left text-xs" style={styles.tableCell}>
                  <div>{item?.name}</div>
                </td>
                <td className="text-center text-xs" style={styles.tableCell}>
                  {item?.description?.number
                    ? `${item?.description?.number}`
                    : ""}
                </td>
                <td className="text-center text-xs" style={styles.tableCell}>
                  {item?.description?.expiry_date
                    ? `${formatDateDDMMYYYY?.(item?.description?.expiry_date)}`
                    : ""}
                </td>
                <td className="text-center text-xs" style={styles.tableCell}>
                  {item?.unit_name}
                </td>
                <td className="text-center text-xs" style={styles.tableCell}>
                  {item?.quantity}
                </td>
                <td className="text-center text-xs" style={styles.tableCell}>
                  {item?.sale_price?.toFixed(3)}
                </td>
                <td className="text-center text-xs" style={styles.tableCell}>
                  {item?.tax_amount?.toFixed(3)}
                </td>
                <td className="text-right pr-2 text-xs" style={styles.tableCell}>
                  {item?.total?.toFixed(3)}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="text-regular">
            <tr style={styles.totalRow}>
              <td
                className="text-regular text-gray-700 text-medium text-xs"
                style={styles.tableCell}
                colSpan="8"
                align="right"
              >
                Subtotal
              </td>
              <td className="text-right pr-2" style={styles.tableCell}>
                {values?.subtotal?.toFixed(3)}
              </td>
            </tr>
            <tr style={styles.totalRow}>
              <td
                className="text-regular text-gray-700 text-medium text-xs"
                style={styles.tableCell}
                colSpan="8"
                align="right"
              >
                Tax [VAT]
              </td>
              <td className="text-right pr-2" style={styles.tableCell}>
                {values?.taxamount?.toFixed(3)}
              </td>
            </tr>
            <tr style={styles.totalRow}>
              <td
                className="text-regular text-gray-700 text-medium text-xs"
                style={styles.tableCell}
                colSpan="8"
                align="right"
              >
                Discount
              </td>
              <td className="text-right pr-2" style={styles.tableCell}>
                {values?.discount?.toFixed(3)}
              </td>
            </tr>
            {/* <tr style={styles.totalRow}>
            <td
              className="text-regular text-gray-700 text-medium text-xs"
              style={styles.tableCell}
              colSpan="5"
              align="right"
            >
              Delivery
            </td>
            <td style={styles.tableCell}>{values?.discount?.toFixed(3)}</td>
          </tr> */}
            <tr style={styles.totalRow}>
              <td
                className="text-regular text-medium text-xs bg-[#f0f0f0]"
                style={styles.tableCell}
                colSpan="8"
                align="right"
              >
                Total
              </td>
              <td
                className="text-right pr-2 text-regular text-medium text-xs bg-[#f0f0f0]"
                style={styles.tableCell}
              >
                {values?.total?.toFixed(3)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
});

const styles = {
  container: {
    width: "100%",
    height: "100%",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeader: {
    backgroundColor: "#f0f0f0",
  },
  tableCell: {
    padding: "8px",
    textAlign: "left",
  },
  totalRow: {
    fontWeight: "normal",
  },
  billingvalues: {
    marginBottom: "20px",
  },
};

export default InvoiceA5;
